import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";

export const isTurboEnabled = (): boolean => {
    const isAccessibilityEnabled =
        GlobalHeaderState.getHeader(SwgyHeaderKeysList.accessibilityEnabled) === "true" || false;
    return !isAccessibilityEnabled;
};
